import { render, staticRenderFns } from "./knowledgePermissions.vue?vue&type=template&id=19af0def&scoped=true"
import script from "./knowledgePermissions.vue?vue&type=script&lang=js"
export * from "./knowledgePermissions.vue?vue&type=script&lang=js"
import style0 from "./knowledgePermissions.vue?vue&type=style&index=0&id=19af0def&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af0def",
  null
  
)

export default component.exports